const FETCH_CREDIT_CARD_INVOICE_DISCOUNT_OPTIONS = 'FETCH_CREDIT_CARD_INVOICE_DISCOUNT_OPTIONS'
const POST_CREDIT_CARD_INVOICE_DISCOUNT_ORDER = 'POST_CREDIT_CARD_INVOICE_DISCOUNT_ORDER'
const defaultMessageError = 'Não foi possível concluir o seu resgate.'
const defaultSubMessageError = 'O resgate do crédito em fatura está indisponível no momento.'

export const getInvoiceDiscountOptions = () => ({
  type: FETCH_CREDIT_CARD_INVOICE_DISCOUNT_OPTIONS,
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: `/v1/purchases/creditCardInvoiceDiscount/options?vendorId=${process.env.REACT_APP_VENDOR_CREDIT_CARD_INVOICE_DISCOUNT}`
    }
  }
})

export const postOrder = (id) => ({
  type: POST_CREDIT_CARD_INVOICE_DISCOUNT_ORDER,
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'post',
      url: `/v1/purchases/creditCardInvoiceDiscount`,
      data: {
        serviceId: id,
        vendorId: process.env.REACT_APP_VENDOR_CREDIT_CARD_INVOICE_DISCOUNT
      }
    }
  }
})

export const clearErrorData = () => ({
  type: 'CLEAR_ERROR_DATA'
})

const initialValue = {
  invoiceParcels: []
}

export default (state = initialValue, action) => {
  switch (action.type) {
    case `${FETCH_CREDIT_CARD_INVOICE_DISCOUNT_OPTIONS}_SUCCESS`:
      var options = action.payload.data.map(d => {
        return {
          id: d.id,
          points: d.priceInPoints,
          credit: d.discountValue,
          catalogId: d.catalogId,
          selected: false
        }
      })
      return {
        ...state,
        options
      }
    case POST_CREDIT_CARD_INVOICE_DISCOUNT_ORDER:
      return {
        ...state,
        processing: true
      }
    case `${POST_CREDIT_CARD_INVOICE_DISCOUNT_ORDER}_SUCCESS`:
      let secondFactorAuthentication = {}
      let authorized = false
      if (action.payload.data.status === 'RequiresTokenValidation') {
        secondFactorAuthentication = {
          enable: true,
          AuthenticationConfirmed: true,
          confirmedOrderId: action.payload.data.id,
          phone: action.payload.data.phone
        }
      } else {
        secondFactorAuthentication = null
        authorized = true
      }
      return {
        ...state,
        invoiceCreditCardDiscountOrder: action.payload.data,
        processing: false,
        secondFactorAuthentication,
        authorized
      }
    case `${FETCH_CREDIT_CARD_INVOICE_DISCOUNT_OPTIONS}_FAIL`:
    case `${POST_CREDIT_CARD_INVOICE_DISCOUNT_ORDER}_FAIL`:
      const {
        response: {
          data,
          status: statusCode
        }
      } = action.error
      const error = data && data.errors ? data.errors : null
      const messages = data && data.messages ? data.messages : null
      const getFirstOnly = (array, param) => ((array && array.length > 0 && array[0][param]) || '')
      const errorData = {
        message: getFirstOnly(error, 'message') || getFirstOnly(messages, 'description') || defaultMessageError,
        subMessage: getFirstOnly(error, 'subMessage') || defaultSubMessageError,
        statusCode,
        code: getFirstOnly(error, 'code') || ''
      }

      if (data && data.status === 'MessageOnBoardingRequired') {
        secondFactorAuthentication = {
          enable: true,
          AuthenticationConfirmed: false
        }
      }

      return {
        ...state,
        errorData,
        secondFactorAuthentication,
        processing: false
      }
    case 'CLEAR_ERROR_DATA':
      return {
        ...state,
        errorData: null
      }
    case 'AUTHORIZE_TOKEN_FAIL':
      let tokenFinishedError = null
      if (action.error.response.data.status === 'TokenFinished') {
        tokenFinishedError = {
          message: 'Não foi possível concluir o seu pagamento',
          subMessage: 'Tentativas de verificação de token excedidas!',
          status: action.error.response.status
        }
      }
      return {
        ...state,
        secondFactorAuthentication: null,
        authorized: false,
        errorData: tokenFinishedError
      }
    case 'AUTHORIZE_TOKEN_SUCCESS':
      if (action.payload.data.status === 'RequiresTokenValidation') {
        return { ...state }
      } else {
        return {
          ...state,
          secondFactorAuthentication: null,
          authorized: true
        }
      }
    case 'GET_ORDER_CONFIRMATION':
      return {
        ...state,
        processing: true
      }
    case 'GET_ORDER_CONFIRMATION_SUCCESS':
      return {
        ...state,
        processing: false,
        orderConfirmed: action.payload.data
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/features/InvoiceCredit/ducks.js